import $ from "jquery";

export class PauseAllAnimations {
  constructor($el) {
    this.$el = $el;
    this.bindEvents();
  }

  bindEvents() {
    this.$el.on("click", function() {
      $("body").toggleClass("is-paused");
    });
  }
}
